import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isExtended: true,
  isExtending: false,
  isMounted: false,
};

const sidePanelSlice = createSlice({
  name: 'sidePanel',
  initialState,
  reducers: {
    extend(state) {
      state.isExtending = true;
      state.isExtended = true;
    },
    doneExtending(state) {
      state.isExtending = false;
    },
    reduce(state) {
      state.isExtended = false;
    },
    mounted(state) {
      state.isMounted = true;
    },
    unmounted(state) {
      state.isMounted = false;
    },
  },
});
export const {
  extend,
  doneExtending,
  reduce,
  mounted,
  unmounted,
} = sidePanelSlice.actions;
export default sidePanelSlice.reducer;
